import { iProProjectMain } from "../models/interfaceProject"
import { AccessType, OriginFile, QuotaUserStatus, TypeFile } from "../constants/enums";
import { getCookie } from "./cookies";
import { globalEmbedData, globalIsEmbedded } from "../context/ConfigContext";
 


/*
export function getChangeName(proProject: iProProjectMain, user:any): string { 
    let name = "" + (proProject.project.project_name??"")
        name = name.toLowerCase()
        name = name.replace(" ", "-")
        name = name.replace(/[^a-zA-Z0-9]/g, '-')
        name = name.replace("--", "-")
        name = name.replace("--", "-")
        name = name.replace("--", "-")
        if (/^\d/.test(name)) {
            name = name.substring(1)
        }
        if (/^\d/.test(name)) {
            name = name.substring(1)
        }
        if (/^\d/.test(name)) {
            name = name.substring(1)
        }
        // name = this.idNameLine(name)
        // this.data_center.database_service_id = this.PREFIX_ID + "" + name 
        // this.key_database_service_id += 1
        //this.key_form += 1 
        return 'inca-ai-'+getDomain(user.email)+name+""+generateUniqueChars();
    }
*/

    export function getChangeName(proProject: iProProjectMain, user: any): string { 
        /*let name = ((proProject.project.project_name ?? "") +" "+ generateUniqueChars() ).toLowerCase()
            .replace(/\s+/g, "-")        // Reemplaza espacios por "-"
            .replace(/[^a-z0-9-]/g, "-") // Sustituye caracteres especiales por "-"
            .replace(/-+/g, "-");        // Elimina múltiples guiones seguidos
    
        // Elimina números al inicio del nombre
        name = name.replace(/^\d+/, "");*/
        console.log("proProject.config.prompt_params.assistant_name", proProject)
        let name = ((proProject.config.prompt_params.assistant_name ?? "") +" "+ generateUniqueChars() ).toLowerCase()
            .replace(/\s+/g, "-")        // Reemplaza espacios por "-"
            .replace(/[^a-z0-9-]/g, "-") // Sustituye caracteres especiales por "-"
            .replace(/-+/g, "-");        // Elimina múltiples guiones seguidos
    
        // Elimina números al inicio del nombre
        name = name.replace(/^\d+/, "");
        return `inca-ai-${getDomain(user.email)}-${name}`;
    }

    
 /// correo del usuario split @ primer elemento intercorp.com.pe "intercorp"
  // PREFIX_ID: 'inca-ai-'+userInfo.domain.split('.')[0]+'-',

    const generateUniqueChars = (): string  => {
        const chars = "abcdefghijklmnopqrstuvwxyz0123456789";
        let result = "";
        while (result.length < 3) {
          const char = chars.charAt(Math.floor(Math.random() * chars.length));
          if (!result.includes(char)) result += char;
        }
        return result;
      };

      const getDomain = (email: string): string => {
        return email.split("@")[1]?.split(".")[0] || "";
      };

      export function maskText(text: string): string {
        return text.length? "•".repeat(text.length):"•".repeat(40);
      }

      export const checkIfFiveMinutesPassed = (createdDateStr: string): boolean => {
        
        const year = parseInt(createdDateStr.substring(0, 4));
        const month = parseInt(createdDateStr.substring(4, 6)) - 1;
        const day = parseInt(createdDateStr.substring(6, 8));
        const hours = parseInt(createdDateStr.substring(8, 10));
        const minutes = parseInt(createdDateStr.substring(10, 12));
        const seconds = parseInt(createdDateStr.substring(12, 14));
      
        const createdDate = new Date(year, month, day, hours, minutes, seconds);
        const now = new Date();
      
        // Comparar diferencia en minutos
        return (now.getTime() - createdDate.getTime()) >= 5 * 60 * 1000;
      };

      export const formatElapsedTime = (minutes: number): string => {
        if (minutes >= 1440) { // más de un día
          const days = Math.floor(minutes / 1440);
          const hours = Math.floor((minutes % 1440) / 60);
          return `${days} día${days !== 1 ? "s" : ""} y ${hours} hora${hours !== 1 ? "s" : ""}`;
        } else if (minutes >= 60) { // más de una hora
          const hours = Math.floor(minutes / 60);
          const mins = Math.floor(minutes % 60);
          return `${hours} hora${hours !== 1 ? "s" : ""} y ${mins} minuto${mins !== 1 ? "s" : ""}`;
        } else {
          return `${Math.floor(minutes)} minuto${minutes !== 1 ? "s" : ""}`;
        }
      };
 
export interface ValidationResult {
  usedProjectQuota: number;
  status: boolean;
  message: string;
}

export const getUsedProjectCuota = (pProject: iProProjectMain): number => { 
  const { quota, quota_config, users = [], groups = [] } = pProject.project;  
  // 1. Sumatoria de cuotas de usuarios individuales
  const sumUsers = users.filter(O=>O.status!== QuotaUserStatus.Deleted).reduce((acc, u) => acc + (u.quota || 0), 0);
  // 2. Sumatoria de cuotas de grupos de usuarios
  const sumGroups = groups.reduce((acc, g) => acc + (g.quota || 0), 0);
  // 3. Total usado
  return sumUsers + sumGroups; 
};

export const validationProjectCuota = (pProject: iProProjectMain, newQuota:number, editQuota:number=0): ValidationResult => {
  // Si no existe configuración de cuota → válido
  if (!pProject?.project?.quota) {
    return { usedProjectQuota: 0, status: true, message: "" };
  }
  const { quota, quota_config, users = [], groups = [] } = pProject.project; 
  // Si no existe cuota definida en el proyecto → válido
  if (!quota_config || quota_config.project_quota === 0) {
    return { usedProjectQuota: 0, status: true, message: "" };
  } 
  // sumar cuotas
  let usedProjectQuota = getUsedProjectCuota(pProject);  
  // validacion couta
  if ((usedProjectQuota + newQuota) > quota && editQuota==0 ) {
    usedProjectQuota = usedProjectQuota+newQuota
    return {
      usedProjectQuota,
      status: false,
      message: `La suma de cuotas ($ ${usedProjectQuota}) superan el límite del proyecto ($ ${quota}) al agregar ($ ${newQuota}).`,
    };
  }else if((usedProjectQuota+editQuota-newQuota) > quota){ 
    usedProjectQuota = usedProjectQuota+editQuota-newQuota
    return {
      usedProjectQuota,
      status: false,
      message: `La suma de cuotas ($ ${usedProjectQuota}) superan el límite del proyecto ($ ${quota}) al actulizar en ($ ${editQuota}).`,
    };
  }

  return {
    usedProjectQuota,
    status: true,
    message: "",
  };
};

export function mapToInterface<T>(source: Record<string, any>, model: T): T {
  const result: Partial<T> = {};
  for (const key in model) {
    if (source[key] !== undefined) {
      result[key] = source[key];
    }
  }
  return result as T;
}


export function getcurrentUser(typeAccess:string, project: iProProjectMain, user: any): string { 
  let clientiditc = getCookie('clientiditc');
  if (globalIsEmbedded && globalEmbedData?.clientiditc) {
    clientiditc = globalEmbedData.clientiditc; 
  } 
  if(typeAccess==AccessType.Incognito){
    if(project?.project?.generic_access){
      return user?.genericUser??clientiditc;
    }
    return clientiditc??"";
  }
  return user.email;
}
 


export function addVersionToFileName(
  fileName: string,
  version: number | string
): string {
  const lastDotIndex = fileName.lastIndexOf('.');

  if (lastDotIndex === -1) {
    // Sin extensión
    return `${fileName}_v${version}`;
  }

  const name = fileName.substring(0, lastDotIndex);
  const ext = fileName.substring(lastDotIndex);

  return `${name}_v${version}${ext}`;
}

 